import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createSetupIntent, createStripePortalLink } from '@/utils/stripe-tools'

/**
 * Hook to create a setup intent for adding payment methods
 * @returns {object} Mutation object
 */
export const useCreateSetupIntent = () => {
  return useMutation({
    mutationFn: createSetupIntent,
  })
}

/**
 * Hook to create a customer portal session using existing function
 * @returns {object} Mutation object
 */
export const useCreateCustomerPortalSession = () => {
  return useMutation({
    mutationFn: createStripePortalLink, // Use existing function
  })
}

/**
 * Hook to refresh payment-related data after Stripe operations
 * @returns {function} Function to refresh data
 */
export const useRefreshStripeData = () => {
  const queryClient = useQueryClient()

  return () => {
    queryClient.invalidateQueries(['userSubscription'])
    queryClient.invalidateQueries(['userPaymentMethods'])
    queryClient.invalidateQueries(['userInvoices'])
  }
}
